import type { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { DataDetailsPage } from './components/DataDetailsPage';

export const ExamplesRouter: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route component={DataDetailsPage} path={`${path}/data-details`} />
    </Switch>
  );
};
